// extracted by mini-css-extract-plugin
export default {"container":"_D-z","title":"aE-z","link":"bE-z"};